export default {
  test: 'Test',
  systemConfig: 'System config',
  logout: 'Logout',
  tip: 'Tip',
  checkLogout: 'Want to logout ?',
  lockScreen:'Lock screen'
}
